import React from 'react';
import {Modal} from "react-bootstrap";

function UserDeleteConfirmModal({showModal, setShowModal, confirm}) {
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title>Potvrda brisanja</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <h5>Da li ste sigurni da želite obrisati korisnika?</h5>
                </div>
                <div className={"modal-footer-component text-right"}>
                    <button className={"btn btn-modal-cancel"} onClick={() => {
                        setShowModal(false)
                    }}>
                        Odustani
                    </button>
                    <button className={"btn btn-modal-confirm-delete"} onClick={confirm}>Obriši</button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default UserDeleteConfirmModal;